// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__ZhyvU","header":"ReportDetails_header__OtaEy","title":"ReportDetails_title__1DSFd","left":"ReportDetails_left__2jJpB"};